import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PagesConfig } from '../../config/pages';
import { Router } from '@angular/router';
import * as objectPath from 'object-path';

@Injectable({
  providedIn: 'root',
})
export class PageConfigService {
  private router = inject(Router);

  public configModel: PagesConfig = new PagesConfig();
  public onPageUpdated$: BehaviorSubject<PagesConfig> = new BehaviorSubject(this.configModel);

  setModel(menuModel: PagesConfig) {
    this.configModel = Object.assign(this.configModel, menuModel);
    this.onPageUpdated$.next(this.configModel);
  }

  getCurrentPageConfig(): any {
    return objectPath.get(
      this.configModel,
      'config.' + this.router.url.substring(1).replace(/\//g, '.')
    );
  }
}
